import { cleanRBIMCode } from "@/lib/rbimCodeMap";

export type HouseholdDeathAgeQuestion = "q58" | "q59";

const deathAgeRules = {
  q58: {
    questionKey: "q58_female_death_past_12_months",
    min: 10,
    max: 54,
    rangeMessage: "Age must be between 10 and 54.",
  },
  q59: {
    questionKey: "q59_child_death_past_12_months",
    min: 0,
    max: 5,
    rangeMessage: "Age must be 5 or below.",
  },
} as const;

export function getHouseholdDeathAgeError(
  question: HouseholdDeathAgeQuestion,
  yesNoValue: string | undefined,
  ageValue: string | undefined,
) {
  const rule = deathAgeRules[question];
  const yesNoResult = cleanRBIMCode(rule.questionKey, yesNoValue);

  if (yesNoResult.error || yesNoResult.code !== "1") {
    return null;
  }

  const normalizedAge = String(ageValue ?? "").trim();

  if (!normalizedAge) {
    return "Age is required.";
  }

  if (!/^\d+$/.test(normalizedAge)) {
    return "Age must be a whole number.";
  }

  const age = Number(normalizedAge);

  if (!Number.isSafeInteger(age) || age < rule.min || age > rule.max) {
    return rule.rangeMessage;
  }

  return null;
}
